import Vue from "vue";

export default {
    install () {
        Vue.prototype.$getAllOrderUnit = async function() {
            let result = [];
            try {
                const response = await this.$http.get(process.env.VUE_APP_ORDER_UNIT_API);
                if (response.data && response.data.success) {
                    result = [].concat(response.data.data)
                }

                return result;
            } catch (e) {
                console.log(e.stack);
                return result;
            }
        };

        Vue.prototype.$getAllOrderUnitByDistrict = async function(districtId) {
            let result = [];
            try {
                const response = await this.$http.get(process.env.VUE_APP_ORDER_UNIT_API + '?vtDistrict=' + districtId);
                if (response.data && response.data.success) {
                    result = [].concat(response.data.data)
                }

                return result;
            } catch (e) {
                console.log(e.stack);
                return result;
            }
        };

        Vue.prototype.$getAllOrderUnitByProvince = async function(provinceId) {
            let result = [];
            try {
                const response = await this.$http.get(process.env.VUE_APP_ORDER_UNIT_API + '?vtProvince=' + provinceId);
                if (response.data && response.data.success) {
                    result = [].concat(response.data.data)
                }

                return result;
            } catch (e) {
                console.log(e.stack);
                return result;
            }
        };
    },
};